@if (label()) {
    <form-label
        [id]="id() + '-label'"
        [forId]="id() + '-datepicker'"
        [label]="label()"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="(control().errors && (control().dirty || control().touched)) || false">
    </form-label>
}

<p-datePicker
    [inputId]="id() + '-datepicker'"
    [formControl]="control()"
    [selectionMode]="selectionMode()"
    [readonlyInput]="readonlyInput()"
    [showClear]="showClear()"
    [showButtonBar]="showButtonBar()"
    [showIcon]="true"
    [placeholder]="placeholder() | translate"
    [appendTo]="'body'"
    [fluid]="true"
    [size]="size()"
    [iconDisplay]="'input'"
    [invalid]="control().invalid && (control().dirty || control().touched)"
    [maxDate]="maxDateTodayUTC() ? endOfCurrentDay : maxDate()"
    (onClose)="onClose()"></p-datePicker>

@if (control().invalid && (control().dirty || control().touched)) {
    @for (error of getErrorKeys(control().errors); track error) {
        <form-error [text]="getErrorMessage(error)"></form-error>
    }
}
